import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import PageHeader from '../../../layout/PageHeader';
import { LOGO_SIZE } from '../../../ui/Logo';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TextContent from '../../../ui/TextContent';
import PageMainContent from '../../../layout/PageMainContent';
import Headline from '../../../ui/Headline';
import RallyPlayers from '../../../modules/GamePlayers';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import Button from '../../../ui/Button';
import PageBottomContent from '../../../layout/PageBottomContent';
import { detectUserAgentInfo, generateTaskRoutePath } from '../../../helpers';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import { getRally } from '../../../api/game-mode/rallies';
import { startGameSession } from '../../../api/game-mode/game-session';
import { saveToken } from '../../../db/auth';
import { GAME_DB } from '../../../db/game';
import { getGameState, getGameTasks } from '../../../api/game-mode/game';
import { useAppDispatch } from '../../../store';
import { selectRallyInfo, setGame, setGameStatus, setGameTasks, setRallyInfo, } from '../../../store/slices/rallyGame';
import { useSelector } from 'react-redux';
import PublicPageLayout from '../../../layout/PublicPageLayout';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import Loader from '../../../ui/Loader';
const RallyRegistrationPage = () => {
    const { id } = useParams();
    const { i18n, t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [rallyPlayers, setRallyPlayers] = useState([]);
    const [isError, setIsError] = useState(false);
    const rally = useSelector(selectRallyInfo);
    const [startRallyIsLoading, setStartRallyIsLoading] = useState(false);
    const [userAgentInfo, setUserAgentInfo] = useState({
        browser: '',
        os: '',
        browserVersion: '',
        osVersion: '',
    });
    useEffect(() => {
        setUserAgentInfo(detectUserAgentInfo());
    }, []);
    useEffect(() => {
        const fetchRally = async () => {
            const rally = await getRally(id);
            dispatch(setRallyInfo(rally));
        };
        fetchRally();
    }, [i18n.language]);
    const handleStartRally = async () => {
        setStartRallyIsLoading(true);
        const activeGame = await GAME_DB.GET.game();
        if (activeGame) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.continueActiveGame.key));
        }
        else {
            const authData = await startGameSession({
                rally: rally.uid,
                gamePlayers: rallyPlayers,
                userAgent: `${userAgentInfo.browser} ${userAgentInfo.browserVersion}`,
                platform: `${userAgentInfo.os} ${userAgentInfo.osVersion}`,
            });
            if (authData) {
                await saveToken('accessToken', authData.token.jwt);
                await saveToken('refreshToken', authData.refreshToken.token);
                try {
                    await GAME_DB.RESET.game();
                }
                catch (error) {
                    console.log('Previous local DB not found. DB is clean to start new Rally');
                }
                const gameTasks = await getGameTasks();
                const gameState = await getGameState();
                if (gameTasks.data && gameTasks.data.length) {
                    await GAME_DB.SET.gameTasks(gameTasks.data);
                    dispatch(setGameTasks(gameTasks.data));
                }
                else {
                    dispatch(setIsModalOpen(true));
                    dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
                }
                if (gameState.data) {
                    await GAME_DB.SET.game({
                        ...gameState.data,
                        localTaskAnswers: [],
                        localAnswersTimeLogs: [],
                        uploads: [],
                    });
                    dispatch(setGame(gameState.data));
                }
                else {
                    dispatch(setIsModalOpen(true));
                    dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
                }
                await GAME_DB.SET.rallyInfo(rally);
                await GAME_DB.SET.gameStatus('active');
                dispatch(setGameStatus('active'));
                setStartRallyIsLoading(false);
                navigate(generateTaskRoutePath(APP_ROUTES.rallyGamePlay, rally.uuid, 1));
            }
            else {
                dispatch(setIsModalOpen(true));
                dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
                setStartRallyIsLoading(false);
            }
        }
    };
    return (_jsx(PublicPageLayout, { children: _jsx("div", { className: 'page-content-wrapper rally-registration-page', children: rally && (_jsxs(_Fragment, { children: [_jsx(PageHeader, { logoSize: LOGO_SIZE.SMALL, title: _jsx(Headline, { title: rally.publicTitle, type: 'h1', layout: 4, spaceBottom: false }), logoLink: '/' }), _jsxs(PageMainContent, { children: [_jsx(Headline, { title: t('manage_players'), type: 'h2', layout: 1 }), _jsx(TextContent, { content: t('game_registration_welcome_text'), html: false }), _jsx(RallyPlayers, { isTeamRally: rally.isTeamRally, onPlayersChange: (addedPlayers) => setRallyPlayers(addedPlayers), onError: (isError) => setIsError(isError) }), startRallyIsLoading && _jsx(Loader, {})] }), _jsx(PageBottomContent, { children: _jsxs(ButtonsGroup, { justify: 'between', children: [_jsx(Button, { label: t('button.back'), variant: 'outlined', onClick: () => navigate('/') }), _jsx(Button, { label: t('button.start_rally'), onClick: handleStartRally, disabled: (rally.isTeamRally ? rallyPlayers.length < 3 : !rallyPlayers.length) || isError })] }) })] })) }) }));
};
export default RallyRegistrationPage;
